/**
 * Сотрудники организации (Owner / FacilityAdmin) для выбора тренера в секциях.
 * Без глобального getUsers.
 */

export function formatOrgStaffRole(role) {
  const r = String(role || '').toLowerCase();
  if (r === 'owner') return 'Владелец';
  if (r === 'facilityadmin') return 'Сотрудник';
  if (r === 'platformadmin') return 'Админ платформы';
  return role || '';
}

export function orgMembersToTrainerOptions(members, complexId) {
  const cid = Number(complexId);
  return (members || [])
    .map((m) => {
      const id = m.userId != null ? m.userId : m.UserId;
      const ids = m.complexIds || m.ComplexIds || [];
      const name = m.userName || m.UserName || '';
      const email = m.userEmail || m.UserEmail || '';
      const role = m.role || m.Role || '';
      const roleLabel = formatOrgStaffRole(role);
      const parts = [name, email, roleLabel].filter(Boolean);
      return {
        id,
        name,
        email,
        role,
        complexIds: ids,
        label: parts.join(' · ') || (id != null ? `Сотрудник ${id}` : 'Сотрудник'),
      };
    })
    .filter((u) => {
      if (u.id == null || Number.isNaN(Number(u.id))) return false;
      if (!cid || Number.isNaN(cid)) return true;
      const ids = u.complexIds || [];
      if (!ids.length) return true;
      return ids.some((id) => Number(id) === cid);
    });
}

export function filterTrainerOptions(options, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return options || [];
  return (options || []).filter((u) => {
    const hay = `${u.label || ''} ${u.name || ''} ${u.email || ''}`.toLowerCase();
    return hay.includes(q);
  });
}
